import { render, staticRenderFns } from "./IconExcel.vue?vue&type=template&id=150dadb5&"
import script from "./IconExcel.vue?vue&type=script&lang=js&"
export * from "./IconExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports